<section class="admin-page ct-page ai-mkt">
  <app-ai-marketing-feature-header
    titleKey="aiMarketing.nav.creatives"
    subtitleKey="aiMarketing.creatives.subtitle"
  >
    <div toolbarActions class="toolbar-actions">
      <button type="button" class="ct-btn ct-btn-primary" (click)="toggleCreateForm()">
        {{ showCreateForm() ? ('aiMarketing.creatives.addClose' | t) : ('aiMarketing.creatives.add' | t) }}
      </button>
    </div>
  </app-ai-marketing-feature-header>

  @if (showCreateForm()) {
    <div class="create-panel">
      <div class="create-grid">
      <div class="ct-card">
        <h3>{{ 'aiMarketing.creatives.uploadTitle' | t }}</h3>
        <p class="muted">{{ 'aiMarketing.creatives.uploadHint' | t }}</p>
        <label class="field">
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp,video/mp4"
            (change)="onFilePicked($event)"
            [disabled]="uploading()"
          />
        </label>
        <button
          type="button"
          class="ct-btn ct-btn-primary"
          [disabled]="uploading() || !selectedFile()"
          (click)="upload()"
        >
          {{ 'aiMarketing.creatives.upload' | t }}
        </button>
      </div>

      <div class="ct-card">
        <h3>{{ 'aiMarketing.creatives.fromProductTitle' | t }}</h3>
        <p class="muted">{{ 'aiMarketing.creatives.fromProductHint' | t }}</p>
        @if (!selectedProduct()) {
          <label class="field">
            <span>{{ 'aiMarketing.creatives.fromProductSearch' | t }}</span>
            <input
              class="ct-input"
              type="search"
              [ngModel]="productSearch()"
              (ngModelChange)="onProductSearchInput($event)"
              [disabled]="creatingFromProduct()"
              [attr.placeholder]="'aiMarketing.creatives.fromProductSearchPlaceholder' | t"
            />
          </label>
          @if (loadingProducts()) {
            <p class="muted">{{ 'common.loading' | t }}</p>
          } @else if (productResults().length) {
            <ul class="product-pick-list">
              @for (p of productResults(); track p.id) {
                <li>
                  <button
                    type="button"
                    class="product-pick-item"
                    [disabled]="creatingFromProduct()"
                    (click)="selectProductFromList(p)"
                  >
                    @if (p.primaryImageUrl) {
                      <img [src]="p.primaryImageUrl" [alt]="p.name" />
                    }
                    <span>{{ p.name }}</span>
                    <span class="muted small">{{ p.sku }}</span>
                  </button>
                </li>
              }
            </ul>
          }
        } @else {
          <div class="selected-product">
            <p><strong>{{ selectedProduct()!.name }}</strong></p>
            @if (selectedProduct()!.images.length > 1) {
              <div class="product-image-picks">
                @for (img of selectedProduct()!.images; track img.id) {
                  <button
                    type="button"
                    class="product-image-pick"
                    [class.selected]="selectedImageId() === img.id"
                    [disabled]="creatingFromProduct()"
                    (click)="selectProductImage(img.id)"
                  >
                    <img [src]="img.url" [alt]="selectedProduct()!.name" />
                  </button>
                }
              </div>
            } @else if (selectedProduct()!.images[0]) {
              <img class="selected-product-preview" [src]="selectedProduct()!.images[0].url" [alt]="selectedProduct()!.name" />
            }
            <label class="field">
              <span>{{ 'aiMarketing.creatives.publishCaption' | t }}</span>
              <textarea
                class="ct-input"
                rows="2"
                [ngModel]="productPrompt()"
                (ngModelChange)="productPrompt.set($event)"
                [disabled]="creatingFromProduct()"
              ></textarea>
            </label>
            <div class="actions">
              <button
                type="button"
                class="ct-btn ct-btn-primary"
                [disabled]="creatingFromProduct() || !selectedImageId()"
                (click)="createFromProduct()"
              >
                {{ 'aiMarketing.creatives.fromProductCreate' | t }}
              </button>
              <button
                type="button"
                class="ct-btn"
                [disabled]="creatingFromProduct()"
                (click)="clearSelectedProduct()"
              >
                {{ 'aiMarketing.creatives.fromProductCancel' | t }}
              </button>
            </div>
          </div>
        }
      </div>
      </div>
    </div>
  }

  <div class="library-filters">
    <form class="filters" (submit)="$event.preventDefault()">
    <select class="ct-select" [ngModel]="status()" (ngModelChange)="status.set($event)" name="status">
      <option value="">{{ 'aiMarketing.creatives.allStatuses' | t }}</option>
      @for (s of statuses; track s) {
        <option [value]="s">{{ statusKey(s) | t }}</option>
      }
    </select>
    <select class="ct-select" [ngModel]="type()" (ngModelChange)="type.set($event)" name="type">
      <option value="">{{ 'aiMarketing.creatives.allTypes' | t }}</option>
      @for (t of types; track t) {
        <option [value]="t">{{ typeKey(t) | t }}</option>
      }
    </select>
    <select class="ct-select" [ngModel]="source()" (ngModelChange)="source.set($event)" name="source">
      <option value="">{{ 'aiMarketing.creatives.allSources' | t }}</option>
      @for (s of sources; track s) {
        <option [value]="s">{{ sourceKey(s) | t }}</option>
      }
    </select>
  </form>
  </div>

  <div class="ct-card">
    <h3 class="library-title">{{ 'aiMarketing.creatives.library' | t }}</h3>
    @if (loading()) {
      <p>{{ 'common.loading' | t }}</p>
    } @else if (loadError()) {
      <p class="muted">{{ loadError() }}</p>
      <button type="button" class="ct-btn ct-btn-sm ct-btn-navy" (click)="reload()">
        {{ 'common.retry' | t }}
      </button>
    } @else if (!filtered().length) {
      <p class="muted">{{ 'aiMarketing.creatives.empty' | t }}</p>
    } @else {
      <div class="creative-grid">
        @for (c of filtered(); track c.id) {
          <article class="creative-card">
            <div
              class="creative-card-media"
              [class.is-publishing]="publishing() && publishTarget()?.id === c.id"
            >
              @if (c.type === 'Video' && c.url) {
                <video [src]="c.url" controls preload="none"></video>
              } @else if (c.thumbnailUrl || c.url) {
                <img [src]="c.thumbnailUrl || c.url" [alt]="c.publicationTitle || c.prompt || ''" />
              }
              @if (publishing() && publishTarget()?.id === c.id) {
                <div class="creative-publishing-overlay" role="status" aria-live="polite" aria-busy="true">
                  <span class="publish-progress-spinner" aria-hidden="true"></span>
                  <span>{{ publishingStatusLabel() }}</span>
                </div>
              }
            </div>
            <div class="creative-card-meta">
              <div class="published-platforms" [attr.aria-label]="'aiMarketing.creatives.publishedOn' | t">
                @if (c.publishedPlatforms?.length) {
                  @for (platform of c.publishedPlatforms; track platform) {
                    <span
                      class="platform-chip"
                      [class.platform-facebook]="platform === 'Facebook'"
                      [class.platform-instagram]="platform === 'Instagram'"
                      [attr.title]="platformKey(platform) | t"
                    >
                      @if (platform === 'Facebook') {
                        <span class="material-symbols-outlined" aria-hidden="true">public</span>
                      } @else if (platform === 'Instagram') {
                        <span class="material-symbols-outlined" aria-hidden="true">photo_camera</span>
                      }
                      <span class="platform-chip-label">{{ platformKey(platform) | t }}</span>
                    </span>
                  }
                }
              </div>
              <p>
                <span
                  class="ct-badge"
                  [class.ct-badge-success]="c.status === 'Approved'"
                  [class.ct-badge-muted]="c.status === 'Generated'"
                >
                  {{ statusKey(c.status) | t }}
                </span>
                · {{ sourceKey(c.source) | t }} · {{ typeKey(c.type) | t }}
              </p>
              <p class="muted">{{ c.createdAt | date: 'medium' }}</p>
              @if (c.publicationTitle) {
                <p class="muted creative-card-title">{{ c.publicationTitle }}</p>
              }
            </div>
            <div class="creative-card-footer">
            @if (canReview(c)) {
              <div class="actions">
                <button
                  type="button"
                  class="ct-btn ct-btn-primary ct-btn-sm"
                  [disabled]="actionId() === c.id"
                  (click)="approve(c.id)"
                >
                  {{ 'aiMarketing.creatives.approve' | t }}
                </button>
                <button
                  type="button"
                  class="ct-btn ct-btn-danger ct-btn-sm"
                  [disabled]="actionId() === c.id"
                  (click)="deleteCreative(c.id)"
                >
                  {{ 'common.delete' | t }}
                </button>
              </div>
            }
            @if (canDelete(c) && !canReview(c)) {
              <div class="actions">
                <button
                  type="button"
                  class="ct-btn ct-btn-danger ct-btn-sm"
                  [disabled]="actionId() === c.id"
                  (click)="deleteCreative(c.id)"
                >
                  {{ 'common.delete' | t }}
                </button>
              </div>
            }
            @if (canPublish(c)) {
              @if (isLoadingPublishOptions(c)) {
                <p class="muted">{{ 'common.loading' | t }}</p>
              } @else if (!getDestinations(c).length) {
                <p class="muted">{{ 'aiMarketing.creatives.publishPlatformsEmpty' | t }}</p>
              } @else if (publishTarget()?.id !== c.id) {
                <div class="platform-publish-buttons actions">
                  @for (d of getDestinations(c); track d.platform) {
                    <button
                      type="button"
                      class="ct-btn ct-btn-sm"
                      [class.ct-btn-navy]="d.canPublish"
                      [disabled]="publishing()"
                      (click)="startPublish(c, d.platform)"
                    >
                      {{ platformKey(d.platform) | t }}
                    </button>
                  }
                </div>
              }
            }
            @if (publishTarget()?.id === c.id && publishPlatform()) {
              <div class="publish-panel">
                @if (activePublishDestination(); as destination) {
                  <p class="publish-panel-title">
                    <strong>{{ platformKey(destination.platform) | t }}</strong>
                    <span class="muted">— {{ destination.label }}</span>
                  </p>
                  @if (!destination.canPublish && destination.disabledReason) {
                    <p class="muted small">{{ destination.disabledReason }}</p>
                  }
                  @if (publishing()) {
                    <p class="publish-progress" role="status" aria-live="polite" aria-busy="true">
                      <span class="publish-progress-spinner" aria-hidden="true"></span>
                      <span>{{ publishingStatusLabel() }}</span>
                    </p>
                    <p class="muted small">{{ 'aiMarketing.creatives.publishingHint' | t }}</p>
                  }
                  <label class="field">
                    <span>{{ 'aiMarketing.creatives.publishCaption' | t }}</span>
                    <textarea
                      class="ct-input"
                      rows="3"
                      [ngModel]="publishCaption()"
                      (ngModelChange)="publishCaption.set($event)"
                      [disabled]="publishing() || !destination.canPublish"
                    ></textarea>
                  </label>
                  <div class="actions">
                    <button
                      type="button"
                      class="ct-btn ct-btn-primary ct-btn-sm"
                      [disabled]="publishing() || !canConfirmPublish()"
                      (click)="confirmPublish()"
                    >
                      @if (publishing()) {
                        {{ 'aiMarketing.creatives.publishing' | t }}
                      } @else {
                        {{ 'aiMarketing.creatives.publish' | t }}
                      }
                    </button>
                    <button
                      type="button"
                      class="ct-btn ct-btn-sm"
                      [disabled]="publishing()"
                      (click)="cancelPublish()"
                    >
                      {{ 'aiMarketing.creatives.publishCancel' | t }}
                    </button>
                  </div>
                } @else if (isLoadingPublishOptions(c)) {
                  <p class="muted">{{ 'common.loading' | t }}</p>
                }
              </div>
            }
            </div>
          </article>
        }
      </div>
    }
  </div>
</section>
